import React from 'react';
import './Map.css';

export default function Map() {
    return(
        <div className="iframe-container">
            <iframe
                title="Address"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ7SeGZiWqD4gRRoOliZapYkE&key=AIzaSyACW0fuhGz_X-HQ8-JAdXZHx3nIf7DL6Ic">
            </iframe>
        </div>
    );
}